import { GroupElement, LayoutElement, PapyrusComponent } from "../types";
import { degreesToRadians } from "../util/math";
import { elementFactory, sortElementsByLayersWithIndex } from "../CommandContext";

export const Group: PapyrusComponent<Omit<GroupElement, "type">> = (props) => {
    const clipPathId = `spiff-group-clip-${props.id}`;
    const rotation = props.rotation || 0;
    const angleInRadians = degreesToRadians(rotation);
    const rotC = Math.cos(angleInRadians);
    const rotS = -Math.sin(angleInRadians);
    const sortedElements = sortElementsByLayersWithIndex(props.children);
    const buildDefinitions = () => {
        return (
            <clipPath id={clipPathId} preserveAspectRatio="none">
                {props.clipPath ? (
                    <path d={props.clipPath} />
                ) : (
                    <rect x={0} y={0} width={props.width} height={props.height} />
                )}
            </clipPath>
        );
    };

    return (
        <>
            <defs>{buildDefinitions()}</defs>
            <g
                transform={`
                matrix(1, 0, 0, 1, ${props.x}, ${props.y})
                matrix(1, 0, 0, 1, ${props.width / 2}, ${props.height / 2})
                matrix(${rotC}, ${-rotS}, ${rotS}, ${rotC}, 0, 0)
                matrix(1, 0, 0, 1, ${-props.width / 2}, ${-props.height / 2})
                `}
            >
                {props._renderingConfiguration?.debug ? (
                    <rect
                        stroke="red"
                        opacity={0.3}
                        fill="none"
                        x={0}
                        y={0}
                        width={props.width}
                        height={props.height}
                    />
                ) : undefined}
                {sortedElements
                    .map((el) => elementFactory(el as LayoutElement))
                    .filter((el) => !!el)
                    .map((el) => (
                        <g clipPath={`url(#${clipPathId})`}>{el}</g>
                    ))}
            </g>
        </>
    );
};
